import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import Logo from "./images/whiteLabelCreated.png";

interface IWhiteLabelCreatedModalProps {
  handleClose: () => void;
  projectLink: string;
}
export default function WhiteLabelCreatedModal({
  handleClose,
  projectLink,
}: IWhiteLabelCreatedModalProps) {
  const { t } = useTranslation();
  const urlLocale = useGetUrlLocale();

  return (
    <Modal show={true} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fs-5">
          {t("whiteLabel.White Lable Created")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden text-center">
        <img
          src={Logo}
          loading="lazy"
          alt="White Lable created"
          className="img-fluid mb-4"
        />
        <div className="mb-3 px-4 mx-2 fs-7">
          {t(
            "whiteLabel.Congratulations! You have successfully connected the White Label. View project preview or create new event!"
          )}
        </div>

        <Row className="gx-3 gy-2 p-2">
          <Col md={6}>
            <Button
              as="a"
              href={`https://${projectLink}`}
              variant="outline-success"
              className="w-100 fw-normal py-3"
              size="sm"
            >
              {t("whiteLabel.Project Preview")}
            </Button>
          </Col>
          <Col md={6}>
            <Link to={`${urlLocale}/create-event`}>
              <Button variant="success" className="w-100 py-3" size="sm">
                {t("firstStep.createEvent")}
              </Button>
            </Link>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
